import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  pageContainer: {
    height: 'calc(100vh - 70px)',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    background: '#fff',
    padding: '16px 24px',
  },
  content: {
    boxSizing: 'border-box',
    padding: '16px 24px',
    overflow: 'hidden',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '23.44px',
    marginBottom: '8px',
    fontFamily: 'Roboto',
  },
  TableContainer: {
    background: '#fff',
    height: '100%',
    overflow: 'auto',
    border: '1px solid #E0E0E0',
  },
}));

export default useStyles;
